/* eslint-disable complexity */
import { useAuthority } from "../../../../../../../utils/hook/useAuthority"

export const useVariablesAuthority = () => {
  const {
    isCommonRefer,
    isCommonTravelerRefer,
    isRoleAdmin,
    isRoleSubAdmin,
    isRoleUser,
    isScheduleChange,
  } = useAuthority()

  const isNotAccessScreen = !isCommonTravelerRefer && !isScheduleChange

  const isVisibleBtnBtn = isRoleAdmin || isRoleSubAdmin || isRoleUser
  const isVisibleBtnCancel = isVisibleBtnBtn && isCommonRefer
  const isVisibleBtnUpdate =
    isVisibleBtnBtn && (isCommonTravelerRefer || isScheduleChange)

  return {
    isNotAccessScreen,
    isVisibleBtnCancel,
    isVisibleBtnUpdate,
  }
}
